<template>
    <div class="page-deliver-todo">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">派送專線</div>
            <div class="breadcrumb-item">派送專線設定</div>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <span style="margin-right:10px;font-family: PingFang SC;font-weight: bold;">派送專線設定列表</span>
                    <div class="pg-btn style2" @click="handleViewOrder">新增</div>
                </div>
            </div>

            <Table size="small"
                border
                no-data-text="暫無數據"
                :columns="columns"
                :data="data">

                <template slot-scope="{ row, index }" slot="time_setting">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn" @click="handleTimeAdd(row)">查看時間列表</div>
                    </div>
                </template>

                <template slot-scope="{ row, index }" slot="address_setting">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn" @click="handleAddressAdd(row)">查看大廈列表</div>
                    </div>
                </template>

                <template slot-scope="{ row, index }" slot="base_day">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn">後{{row.base_day}}天</div>
                    </div>
                </template>

                <template slot-scope="{ row, index }" slot="not_onduty_setting">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn" @click="handleSelectDateTime(row.id)">不派送日期選擇列表</div>
                    </div>
                    <!-- <el-date-picker
                      size="small"
                      type="dates"
                      v-model="not_onduty_value"
                      placeholder="選擇一個或多個日期">
                    </el-date-picker> -->
                </template>

                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <!-- <div class="pg-btn style2" @click="handleEdit(row)">確定修改</div> -->
                        <div class="pg-btn style2" @click="handleUpdateChildren(row)">同步派送时间</div>

                        <div class="pg-btn style1" @click="handleDelete(row)">刪除</div>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="11" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="13" class="pagger-right">
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="total"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>

        <Modal v-model="isShowModalSign_goods"
               title="派送專線設定列表 (新增)"
               width="600"
               :footer-hide="true"
               @on-cancel="handleModalSignClose_goods">
            <div class="modal-cont">
               <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
                    <div class="loading-text">Loading</div>
                </Spin>
                <div class="pg-form-wrap">
                    <Row>
                    <Col span="200" push="3">
                        <Form :label-width="150">
                            <Row>
                                <Col span="16">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>專線名稱</span>
                                        </div>
                                        <Input v-model="form.name"/>
                                    </FormItem>
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>基礎時間設定</span>
                                        </div>
                                        <TimePicker format="HH:mm" placeholder="預設值為00:00" style="width: 100%" v-model="form.base_time" default-value='00:00' :clearable="false" :editable="false"></TimePicker>
                                    </FormItem>
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>基礎天數設定</span>
                                        </div>
                                        <Select v-model="form.base_day" placeholder="基礎天數設定">
                                            <Option :value="1">後1天</Option>
                                            <Option :value="2">後2天</Option>
                                            <Option :value="3">後3天</Option>
                                            <Option :value="5">後5天</Option>
                                            <Option :value="7">後7天</Option>
                                            <Option :value="10">後10天</Option>
                                        </Select>
                                    </FormItem>
                                    <!-- <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>使用人數</span>
                                        </div>
                                        <InputNumber type="number" :min="0" :max="9999" v-model="form.base_people" style="width: 100%"/>
                                    </FormItem> -->
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>備註</span>
                                        </div>
                                        <Input v-model="form.remark" maxlength="100" show-word-limit type="textarea" placeholder="備註" style="width: 100%" :rows="4" />
                                    </FormItem>
                                    <FormItem>
                                        <div class="pg-btn-wrap">
                                            <div class="pg-btn style1" @click="handleCheckForm">確認添加</div>
                                        </div>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                      </Col>
                    </Row>
                </div>
            </div>
        </Modal>

        <!--<Modal v-model="isShowModalSign_notduty"
               title="不派送日期選擇列表(設定)"
               width="600"
               :footer-hide="true"
               @on-cancel="handleModalSignClose_notduty">
            <div class="modal-cont">
               <Spin fix class="pg-sub-loading" v-if="isSubmitingnotduty">
                    <div class="loading-text">Loading</div>
                </Spin>
                <div class="pg-form-wrap">
                    <Row>
                    <Col span="200" push="3">
                        <Form :label-width="150">
                            <Row>
                                <Col span="16">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>選擇日期</span>
                                        </div>

                                        &lt;!&ndash; <el-date-picker
                                          size="small"
                                          type="dates"
                                          format="yyyy-MM-dd"
                                          value-format="yyyy-MM-dd"
                                          v-model="not_onduty_value"
                                          placeholder="選擇一個或多個日期"
                                          :clearable="false"
                                          :picker-options="pickerOptions"
                                          @change="handleDateChange(not_onduty_id,not_onduty_did,not_onduty_value)">
                                        </el-date-picker> &ndash;&gt;

                                        <el-date-picker
                                          size="small"
                                          type="dates"
                                          format="yyyy-MM-dd"
                                          value-format="yyyy-MM-dd"
                                          v-model="not_onduty_value"
                                          placeholder="選擇一個或多個日期"
                                          :clearable="false"
                                          @change="handleDateChange(not_onduty_id,not_onduty_did,not_onduty_value)">
                                        </el-date-picker>

                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                      </Col>
                    </Row>
                </div>
            </div>
        </Modal>-->
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        data() {
            return {
                pickerOptions: {
                  disabledDate(time) {
                    return new Date(time).getDay() === 0;
                  }
                },
                not_test: [],
                not_onduty_did: '',
                not_onduty_id: [],
                not_onduty_value: [],
                isShowModalSign_goods: false,
                isShowModalSign_notduty: false,
                isSubmitingLog: false,
                isSubmitingnotduty: false,
                isSubmiting: false,
                pageInput: '',
                pageIndex: 1,
                curPageSize: 1000,
                totalCount: 1,
                form: {
                    name: '',
                    base_time: '00:00',
                    base_day: 3,
                    // base_people: 0,
                    remark: ''
                },
                columns:[
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        align: 'center',
                        title: '專線名稱',
                        key: 'name',
                        sortable: true,
                        minWidth: 100,
                        render: (h, {row, index}) => {
                            let edit;
                            let control;
                            if (this.editIndex === index) {
                                edit = [h('Input', {
                                    style: {
                                        cursor: 'pointer',
                                        margin: '8px'
                                    },
                                    props: {
                                        value: row.name
                                    },
                                    on: {
                                        input: (val) => {
                                            this.editValue = val;
                                        }
                                    }
                                })];
                                control = [
                                    h('Icon', {
                                        style: {
                                            cursor: 'pointer',
                                            margin: '8px'
                                        },
                                        props: {
                                            type: 'md-checkmark',
                                            size: 16,
                                            color: '#19be6b'
                                        },
                                        on: {
                                            click: () => {
                                                this.data[index].name = this.editValue;
                                                this.editIndex = -1;

                                                this.$Rq.requestAuth({
                                                    url: this.$Api.deliveryareaEdit,
                                                    method: 'post',
                                                    data: {
                                                        delivery_id: Number(row.id),
                                                        name: this.editValue,
                                                    }
                                                }).then((res) =>
                                                {
                                                    if (res.code == 0)
                                                    {
                                                        this.pickAddress = res.data.data;
                                                        this.data[index].name = this.editValue;
                                                        this.$Message.success('修改專線名稱成功');
                                                    }
                                                    else{
                                                        this.$Message.error('修改專線名稱失敗');
                                                    }
                                                });
                                            }
                                        }
                                    }),
                                    h('Icon', {
                                        style: {
                                            cursor: 'pointer',
                                            margin: '8px'
                                        },
                                        props: {
                                            type: 'md-close',
                                            size: 16,
                                            color: '#ed4014'
                                        },
                                        on: {
                                            click: () => {
                                                this.editIndex = -1;
                                            }
                                        }
                                    })
                                ]
                            } else {
                                edit = row.name;
                                control = [h('Icon', {
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    props: {
                                        type: 'ios-create-outline',
                                        size: 16
                                    },
                                    on: {
                                        click: () => {
                                            this.editIndex = index;
                                            this.editValue = row.name;
                                        }
                                    }
                                })]
                            }
                            return h('Row', [
                                h('Col', {
                                    props: {
                                        span: 16
                                    }
                                }, edit),
                                h('Col', {
                                    props: {
                                        span: 6
                                    }
                                }, control)
                            ])
                        }
                    },
                    {
                        align: 'center',
                        title: '派送大廈設定',
                        slot: 'address_setting',
                        key: 'address_setting',
                        minWidth: 110,
                        tooltip:true,
                    },
                    {
                        align: 'center',
                        title: '派送時間設定',
                        key: 'time_setting',
                        slot: 'time_setting',
                        minWidth: 100,
                        // sortable: true,
                        // render: (h, {row}) => {
                        //     if (row.status === 1) {
                        //         return h('Tag', {
                        //             props: {
                        //                 color: 'green'
                        //             }
                        //         }, "等级 1")
                        //     } else if (row.status === 2) {
                        //         return h('Tag', {
                        //             props: {
                        //                 color: 'red'
                        //             }
                        //         }, "等级 2")
                        //     } else if (row.status === 3) {
                        //         return h('Tag', {
                        //             props: {
                        //                 color: 'blue'
                        //             }
                        //         }, "等级 3")
                        //     }
                        // },
                    },
                    {
                        align: 'center',
                        key: 'basic_time_setting',
                        minWidth: 110,
                        render: (h, {row, index}) => {
                            let edit;
                            let control;
                            if (this.editbasicIndex === index) {
                                edit = [h('TimePicker', {
                                    style: {
                                        cursor: 'pointer',
                                        margin: '8px',
                                        width: '100%',
                                    },
                                    props: {
                                        transfer: true,
                                        clearable: false,
                                        format: "HH:mm",
                                        value: row.base_time,
                                    },
                                    on: {
                                        input: (val) => {
                                            this.editbasicValue = val;
                                        }
                                    }
                                })];
                                control = [
                                    h('Icon', {
                                        style: {
                                            cursor: 'pointer',
                                            margin: '8px'
                                        },
                                        props: {
                                            type: 'md-checkmark',
                                            size: 16,
                                            color: '#19be6b'
                                        },
                                        on: {
                                            click: () => {
                                                this.editbasicIndex = -1;
                                                this.$Rq.requestAuth({
                                                    url: this.$Api.deliveryareaEdit,
                                                    method: 'post',
                                                    data: {
                                                        delivery_id: Number(row.id),
                                                        name: row.name,
                                                        base_time: this.editbasicValue,
                                                        base_day: row.base_day,
                                                        // base_people: row.base_people,
                                                        remark: row.remark,
                                                    }
                                                }).then((res) =>
                                                {
                                                    if (res.code == 0)
                                                    {
                                                        this.pickAddress = res.data.data;
                                                        this.data[index].base_time = this.editbasicValue;
                                                        this.$Message.success('修改基礎時間設定成功');
                                                    }
                                                    else{
                                                        this.$Message.error('修改基礎時間設定失敗');
                                                    }
                                                });
                                            }
                                        }
                                    }),
                                    h('Icon', {
                                        style: {
                                            cursor: 'pointer',
                                            margin: '8px'
                                        },
                                        props: {
                                            type: 'md-close',
                                            size: 16,
                                            color: '#ed4014'
                                        },
                                        on: {
                                            click: () => {
                                                this.editbasicIndex = -1;
                                            }
                                        }
                                    })
                                ]
                            } else {
                                edit = row.base_time.substring(0,5);
                                control = [h('Icon', {
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    props: {
                                        type: 'ios-create-outline',
                                        size: 16
                                    },
                                    on: {
                                        click: () => {
                                            this.editbasicIndex = index;
                                            this.editbasicValue = row.base_time;
                                        }
                                    }
                                })]
                            }
                            return h('Row', [
                                h('Col', {
                                    props: {
                                        span: 16
                                    }
                                }, edit),
                                h('Col', {
                                    props: {
                                        span: 6
                                    }
                                }, control)
                            ])
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                              h('span', '基礎時間設定'),
                              h('Tooltip', {
                                props: {
                                  transfer: true,
                                  placement: 'top',
                                  theme: 'light'
                                }
                              }, [
                                h('Icon', {
                                  props: {
                                    type: 'md-help-circle',
                                    color: "#c8c8c8",
                                    size: "15"
                                  },
                                  class: {iconClass: true}
                                }),
                                h('div', {
                                      slot: 'content',
                                      style: {
                                          whiteSpace: 'normal'
                                       }
                                  }, '定義：在此時間前，用戶能約當天訂單；超過此時間選明天之後訂單。'
                                ),
                              ]),
                            ])
                        }
                    },
                    {
                        align: 'center',
                        slot: 'base_day',
                        key: 'base_day',
                        minWidth: 110,
                        render: (h, {row, index}) => {
                            let edit;
                            let control;
                            if (this.editdayIndex === index) {
                                edit = [h('Select', {
                                        style: {
                                            cursor: 'pointer',
                                            margin: '8px',
                                            width: '100%',
                                        },
                                        props: {
                                            transfer: true,
                                            placeholder: "基礎天數設定",
                                            value: row.base_day
                                        },
                                        on: {
                                            input: (val) => {
                                                this.editdayValue = val;
                                            }
                                        }
                                    },
                                    [
                                        h('Option', {
                                            props: {
                                                value: 1
                                            }
                                        },'後1天'
                                        ),
                                        h('Option', {
                                            props: {
                                                value: 2
                                            }
                                        },'後2天'
                                        ),
                                        h('Option', {
                                            props: {
                                                value: 3
                                            }
                                        },'後3天'
                                        ),
                                        h('Option', {
                                            props: {
                                                value: 5
                                            }
                                        },'後5天'
                                        ),
                                        h('Option', {
                                            props: {
                                                value: 7
                                            }
                                        },'後7天'
                                        ),
                                        h('Option', {
                                            props: {
                                                value: 10
                                            }
                                        },'後10天')
                                    ]
                                )];
                                control = [
                                    h('Icon', {
                                        style: {
                                            cursor: 'pointer',
                                            margin: '8px'
                                        },
                                        props: {
                                            type: 'md-checkmark',
                                            size: 16,
                                            color: '#19be6b'
                                        },
                                        on: {
                                            click: () => {
                                                this.data[index].base_day = this.editdayValue;
                                                this.editdayIndex = -1;

                                                this.$Rq.requestAuth({
                                                    url: this.$Api.deliveryareaEdit,
                                                    method: 'post',
                                                    data: {
                                                        delivery_id: Number(row.id),
                                                        base_day: this.editdayValue,
                                                    }
                                                }).then((res) =>
                                                {
                                                    if (res.code == 0)
                                                    {
                                                        this.pickAddress = res.data.data;
                                                        this.data[index].base_day = this.editdayValue;
                                                        this.$Message.success('修改基礎天數設定成功');
                                                    }
                                                    else{
                                                        this.$Message.error('修改基礎天數設定失敗');
                                                    }
                                                });
                                            }
                                        }
                                    }),
                                    h('Icon', {
                                        style: {
                                            cursor: 'pointer',
                                            margin: '8px'
                                        },
                                        props: {
                                            type: 'md-close',
                                            size: 16,
                                            color: '#ed4014'
                                        },
                                        on: {
                                            click: () => {
                                                this.editdayIndex = -1;
                                            }
                                        }
                                    })
                                ]
                            } else {
                                edit = '後'+row.base_day+'天';
                                control = [h('Icon', {
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    props: {
                                        type: 'ios-create-outline',
                                        size: 16
                                    },
                                    on: {
                                        click: () => {
                                            this.editdayIndex = index;
                                            this.editdayValue = row.base_day;
                                        }
                                    }
                                })]
                            }
                            return h('Row', [
                                h('Col', {
                                    props: {
                                        span: 16
                                    }
                                }, edit),
                                h('Col', {
                                    props: {
                                        span: 6
                                    }
                                }, control)
                            ])
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                              h('span', '基礎天數設定'),
                              h('Tooltip', {
                                props: {
                                  transfer: true,
                                  placement: 'top',
                                  theme: 'light'
                                }
                              }, [
                                h('Icon', {
                                  props: {
                                    type: 'md-help-circle',
                                    color: "#c8c8c8",
                                    size: "15"
                                  },
                                  class: {iconClass: true}
                                }),
                                h('div', {
                                      slot: 'content',
                                      style: {
                                          whiteSpace: 'normal'
                                       }
                                  }, '定義：基於基礎時間用戶能選擇后幾天派送'
                                ),
                              ]),
                            ])
                        }
                    },
                    /*{
                        title: '不派送日期選擇',
                        align: 'center',
                        key: 'not_onduty_setting',
                        slot: 'not_onduty_setting',
                        minWidth: 150
                    },*/
                    {
                        title: '最大使用人數',
                        key: 'base_people',
                        align: 'center',
                        sortable: true,
                        minWidth: 100
                    },
                    {
                        title: '備註',
                        key: 'remark',
                        align: 'center',
                        sortable: true,
                        minWidth: 100,
                        render: (h, {row, index}) => {
                            let edit;
                            let control;
                            if (this.editremarkIndex === index) {
                                edit = [h('Input', {
                                    style: {
                                        cursor: 'pointer',
                                        margin: '8px'
                                    },
                                    props: {
                                        value: row.remark
                                    },
                                    on: {
                                        input: (val) => {
                                            this.editremarkValue = val;
                                        }
                                    }
                                })];
                                control = [
                                    h('Icon', {
                                        style: {
                                            cursor: 'pointer',
                                            margin: '8px'
                                        },
                                        props: {
                                            type: 'md-checkmark',
                                            size: 16,
                                            color: '#19be6b'
                                        },
                                        on: {
                                            click: () => {
                                                this.data[index].remark = this.editremarkValue;
                                                this.editremarkIndex = -1;

                                                this.$Rq.requestAuth({
                                                    url: this.$Api.deliveryareaEdit,
                                                    method: 'post',
                                                    data: {
                                                        delivery_id: Number(row.id),
                                                        remark: this.editremarkValue,
                                                    }
                                                }).then((res) =>
                                                {
                                                    if (res.code == 0)
                                                    {
                                                        this.pickAddress = res.data.data;
                                                        this.data[index].remark = this.editremarkValue;
                                                        this.$Message.success('修改備註成功');
                                                    }
                                                    else{
                                                        this.$Message.error('修改備註失敗');
                                                    }
                                                });
                                            }
                                        }
                                    }),
                                    h('Icon', {
                                        style: {
                                            cursor: 'pointer',
                                            margin: '8px'
                                        },
                                        props: {
                                            type: 'md-close',
                                            size: 16,
                                            color: '#ed4014'
                                        },
                                        on: {
                                            click: () => {
                                                this.editremarkIndex = -1;
                                            }
                                        }
                                    })
                                ]
                            } else {
                                edit = row.remark;
                                control = [h('Icon', {
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    props: {
                                        type: 'ios-create-outline',
                                        size: 16
                                    },
                                    on: {
                                        click: () => {
                                            this.editremarkIndex = index;
                                            this.editremarkValue = row.remark;
                                        }
                                    }
                                })]
                            }
                            return h('Row', [
                                h('Col', {
                                    props: {
                                        span: 16
                                    }
                                }, edit),
                                h('Col', {
                                    props: {
                                        span: 6
                                    }
                                }, control)
                            ])
                        }
                    },

                ],
                data: [],
                loading: false,
                total: 0,
                editIndex: -1,
                editbasicIndex: -1,
                editdayIndex: -1,
                editremarkIndex: -1,
                editValue: '',
                editbasicValue: '',
                editdayValue: '',
                editremarkValue: '',
            }
        },
        methods:{
            // 同步子项
            async handleUpdateChildren(row) {
                const { code, msg } = await this.$Rq.requestAuth({
                    url: this.$Api.deliveryareaDateSynchronize,
                    method: 'post',
                    data: {delive_id: row.id,}
                })
                this.$message.success(msg)
            },
            handleDateChange(id,did,time){

                let filter = this.not_test.filter((item,index)=>{
                    return !time.includes(item.time);
                })
                let filter2 = this.not_test.filter((item,index)=>{
                    return time.includes(item.time);
                })

                let filter_array = [];
                for(let i=0; i < filter2.length; i++) {
                    let f_time = filter2[i].time;
                    if(time.includes(f_time)){
                        filter_array.push(f_time);
                    }
                }

                let filter_delete = [];
                for (let i = 0 ; i < time.length; i++){
                    if(!filter_array.includes(time[i])){
                       filter_delete.push(time[i]);
                    }
                }

                if(filter.length > 0){
                    for(let i = 0; i < filter.length; i++){
                        this.handleDateDelete(did,filter[i])
                    }
                }

                if(filter_delete.length > 0){
                    this.handleDateAdd(did,filter_delete);
                }

                // let id_array = id.length;
                // let time_items = time.splice(id_array);
                // this.handleDateAdd(did,time_items);
                // for(let i = 0; i < items.length; i++){
                //     this.handleDateAdd(did,items);
                // }
                // this.handleDateEdit(id,did,item);
            },
            handleDateAdd(did_add,time_add) {
                this.isSubmitingnotduty = true;
                this.$Rq.requestAuth({
                   url: this.$Api.deliveryareaConfigTimeAdd,
                   method: 'post',
                   data: {
                      did: did_add,
                      time: time_add,
                   }
                }).then((res) => {
                   this.isSubmitingnotduty = false;

                   if (res.code == 0) {
                        this.$Utils.showSuccess(res.msg);
                        this.getList(did_add);
                    }
                    else {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                   this.isSubmitingnotduty = false;
                });
            },
            handleDateDelete(did,item) {
                let id = item.id;

                this.isSubmitingnotduty = true;
                this.$Rq.requestAuth({
                   url: this.$Api.deliveryareaConfigTimeDelete,
                   method: 'post',
                   data: {
                       id: id
                   }
                }).then((res) => {
                   this.isSubmitingnotduty = false;
                   if (res.code == 0) {
                      this.$Utils.showSuccess(res.msg);
                      this.getList(did);
                   } else {
                      this.$Utils.showTipInfo(res.msg);
                   }
                }).catch((err) => {
                   this.isSubmitingnotduty = false;
                });
            },
            handleDateEdit(edit_id,edit_did,time_setting) {
                let id = edit_id;
                let did = edit_did;
                let time = time_setting;

                if (time === '' || time === null) {
                   this.$Utils.showTipInfo('請選擇不派送日期');
                   return;
                }

               this.isSubmiting = true;

               this.$Rq.requestAuth({
                  url: this.$Api.deliveryareaConfigTimeEdit,
                  method: 'post',
                  data: {
                   id: id,
                   did: did,
                   time: time,
                  }
               }).then((res) =>
               {
                  this.isSubmiting = false;

                  if (res.code == 0)
                  {
                     this.$Utils.showSuccess(res.msg);
                     if(this.pageParam.id == undefined || this.pageParam.id == "") {
                         this.getList();
                    }
                    else {
                        this.getList(this.pageParam.id);
                    }
                  } else
                  {
                     this.$Utils.showTipInfo(res.msg);
                     if(this.pageParam.id == undefined || this.pageParam.id == "") {
                         this.getList();
                    }
                    else {
                        this.getList(this.pageParam.id);
                    }
                  }
               }).catch((err) =>
               {
                  this.isSubmiting = false;
               });
            },
            handleNotDutyAdd(item) {
                this.$router.push({path: '/deliveryareanotdutySetting?id=' + item.id});
            },
            handleAddressAdd(item) {
                this.$router.push({path: '/deliveryareaaddressSetting?id=' + item.id});
            },
            handleTimeAdd(item) {
                this.$router.push({path: '/deliveryareatimeSetting?id=' + item.id});
            },
            handleViewOrder(index) {
                this.isShowModalSign_goods = true;
            },
            handleSelectDateTime(index) {
                this.isShowModalSign_notduty = true;
                this.getList(index);
            },
            handleModalSignClose_goods(){
                this.isShowModalSign_goods = false;
            },
            handleModalSignClose_notduty(){
                this.isShowModalSign_notduty = false;
            },
            handleDelete(item) {
                let id = item.id;
                this.$Modal.confirm({
                  title: '提示',
                  content: '確定刪除嗎？',
                  cancelText: '取消',
                  okText: '確定',
                  onOk: () => {
                     this.isSubmiting = true;
                     this.$Rq.requestAuth({
                        url: this.$Api.deliveryareaDelete,
                        method: 'post',
                        data: {
                            delivery_id: id
                        }
                     }).then((res) => {
                        this.isSubmiting = false;
                        if (res.code == 0) {
                           this.$Utils.showSuccess(res.msg);
                           this.getData();
                        } else {
                           this.$Utils.showTipInfo(res.msg);
                        }
                     }).catch((err) => {
                        this.isSubmiting = false;
                     });
                  }
               });
            },
            getList(item) {
                let api;
                if(item != null){
                    api = this.$Api.deliveryareaConfigTimeList + '?did=' + item;
                }else{
                    api = this.$Api.deliveryareaConfigTimeList;
                }

                let form = this.form;
                this.isSubmitingnotduty = true;
                this.$Rq.requestAuth({
                    url: api,
                    method: 'get',
                    data:{
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                    }
                }).then((res) => {
                    this.isSubmitingnotduty = false;
                    if (res.code == 0) {
                        let tempArr = [];
                        let tempDate = [];
                        let tempID = [];
                        let tempTest = [];
                        let resData = res.data.data;
                        for (let i = 0; i < resData.length; i++) {

                            tempDate.push(resData[i].time);

                            tempID.push(resData[i].id);

                            tempTest.push({
                                id: resData[i].id,
                                time: resData[i].time,
                            });

                            tempArr.push({
                                id: resData[i].id,
                                did: resData[i].did,
                                time: resData[i].time,
                            });
                        }

                        // this.totalCount = res.data.count;
                        this.not_onduty_id = tempID;
                        this.not_onduty_did = item;
                        this.not_onduty_value = tempDate;
                        this.not_test = tempTest;
                        this.table.data = tempArr;
                    } else {
                        this.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmitingnotduty = false;
                });
            },
            getData(){
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.deliveryareaList,
                    method: 'get',
                    data: {
                        name: '',
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        this.data = res.data.data;
                        this.total = res.data.count;
                        this.totalCount = res.data.count;

                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },
            handleCheckForm() {

                let form = this.form;

                if (form.name === '') {
                   this.$Utils.showTipInfo('請輸入專線名稱');
                   return;
                } else if (form.base_time === '') {
                   this.$Utils.showTipInfo('請選擇基礎時間設定');
                   return;
                } else if (form.base_day === '') {
                   this.$Utils.showTipInfo('請選擇基礎天數設定');
                   return;
                }
                // else if (form.base_people === '') {
                //    this.$Utils.showTipInfo('請輸入最大使用人數');
                //    return;
                // }
                else if (form.remark === '') {
                   this.$Utils.showTipInfo('請輸入備註');
                   return;
                }

                this.handleSubmit();
            },
            handleSubmit() {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                   url: this.$Api.deliveryareaAdd,
                   method: 'post',
                   data: {
                      name: form.name,
                      base_time: form.base_time,
                      base_day: form.base_day,
                      // base_people: form.base_people,
                      remark: form.remark
                   }
                }).then((res) => {
                   this.isSubmiting = false;

                   if (res.code == 0) {
                      this.$Utils.showSuccess(res.msg);
                      this.form = {
                        name: '',
                        base_time: '00:00',
                        base_day: 3,
                        // base_people: 0,
                        remark: ''
                      };
                      this.handleModalSignClose_goods();
                      this.getData();
                   } else {
                      this.$Utils.showTipInfo(res.msg);
                   }
                }).catch((err) => {
                   this.isSubmiting = false;
                });
            },
            handleChangeSize(val){
                this.curPageSize = val;
                this.$nextTick(() => {
                    this.getData();
                })
            },
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getData();
            },
            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getData();
            },
            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getData();
            }
        },
        created() {
            this.getData();
        },
        activated()
        {
            this.getData();
        }
    }
</script>
<style lang="scss" scoped>
    @import "deliveryareaSetting.scss";
</style>
